import { Injectable } from "@angular/core";
import { BaseApiService } from "../shared/_base.api.service";
import { FilterType } from "../../utils/types/shared/_filter.type";
import { PagedApiResponse } from "../../utils/types/shared/_paged-api-response.type";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { PeriodContactability } from "../../utils/types/period-contactability/periodContactability.type";
import { PeriodContactabilityMapper } from "../../utils/mappers/period-contactability/period-contactability.mapper";
import { PERIOD_CONTACTABILITY_ENDPOINTS } from "../../components/mediaManager/admon/period-contactability/period-contactability-endpoints";

@Injectable({ providedIn: "root" })
export class PeriodContactabilityService extends BaseApiService<PeriodContactability> {
    model = PeriodContactability;
    mapper = new PeriodContactabilityMapper();
    apiEndPoint: any = PERIOD_CONTACTABILITY_ENDPOINTS;

    create(data: PeriodContactability): Observable<boolean> {
        return this.http.post<boolean>(this.apiEndPoint.list, data).pipe(
            map((res) => {
                return res;
            })
        );
    }
    getList(
        filter?: FilterType
    ): Observable<PagedApiResponse<PeriodContactability>> {
        return this.http.get(this.apiEndPoint.list).pipe(
            map((res) => {
                return this.sharedMapper.mapPagedApiResponse(
                    res,
                    this.mapper.mapList,
                    this.model
                );
            })
        );
    }

    getListByStatus(
        filter?: FilterType,
        status?: number
    ): Observable<PagedApiResponse<PeriodContactability>> {
        return this.http
            .get(this.apiEndPoint.status.replace("{status}", status))
            .pipe(
                map((res) => {
                    return this.sharedMapper.mapPagedApiResponse(
                        res,
                        this.mapper.mapList,
                        this.model
                    );
                })
            );
    }

    update(data: PeriodContactability): Observable<boolean> {
        const { id } = data;
        const endpoint = this.apiEndPoint.item.replace("{id}", id.toString());
        return this.http.put<boolean>(endpoint, data);
    }

    delete(id: number): Observable<boolean> {
        const endpoint = this.apiEndPoint.item.replace("{id}", id.toString());
        return this.http.delete<boolean>(endpoint);
    }
}
